export const addresses = {
  alphabetProvider:"0xd703362287D6B578612AC0Ef01f2121eB69671e6",
}
